export function navigateToUrl(path) {
  const url = `${path}`
  window.location.href = `#${url}`
}
